import { Grid } from '@mui/material';

import { useRestaurantName } from 'reservations/account/providers/ConfigProvider';
import Header from 'reservations/base/components/Header';
import { WHITE } from 'reservations/brand/helpers/v1/palette';

export const TextOnlyLayout = () => {
  const restaurantName = useRestaurantName();

  return (
    <Grid
      data-testid="text-only-layout"
      sx={{
        display: 'grid',
        width: '100%',
        alignItems: 'end',
        justifyContent: 'start'
      }}
    >
      <Header
        text={restaurantName}
        color={WHITE}
        fontSize={`${560 / restaurantName?.length}px`}
      />
    </Grid>
  );
};
